// extracted by mini-css-extract-plugin
export default {"SuggestContent":"EZNio","SuggestTitle":"QoZV9"};